import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Label } from '@atlas/ui';

import SeoPageText from 'components/SeoPage/SeoPageText';
import useSeoPage from 'components/SeoPage/useSeoPage';

const CmsPageList = () => {
  const { pageList } = useSeoPage();

  const renderRows = useMemo(
    () =>
      pageList?.map(page => (
        <tr>
          <td>{page.name}</td>
          <td>
            <Link to={`/page${page.slug?.startsWith('/') ? '' : '/'}${page.slug}`}>
              {page.slug}
            </Link>
          </td>
          <td>{page.title}</td>
          <td>{page.meta_title}</td>
          <td>{page.meta_keywords}</td>
        </tr>
      )),
    [pageList],
  );

  return (
    <div className="page-list">
      <div className="page-list-content">
        <table>
          <tr>
            <th>
              <Label message="name" />
            </th>
            <th>
              <Label message="link" />
            </th>
            <th>
              <Label message="title" />
            </th>
            <th>
              <Label message="meta_title" />
            </th>
            <th>
              <Label message="meta_keywords" />
            </th>
          </tr>
          {renderRows}
        </table>
        <SeoPageText />
      </div>
    </div>
  );
};

export default CmsPageList;
